import React, { useState, useRef, useEffect } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import TabPanel from "../custom/containers/TabPanel";
import ChangePassword from "../User/ChangePassword";
import UserProfile from "../User/UserProfile";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import passwordActionTypes from "../../actions/types/password.action.type";
import ERPSBaseTab from "../custom/inputs/ERPSBaseTab";
import {listProps,   getComponentAccess } from "../../utils/helper";
import { ResponsiveBox, Tab, Tabs, Typography } from "../primitives";

const AccountSettings = (props) => {
  const { t } = useTranslation();
  const loginUser = useSelector((state) => state.loginUserReducer?.user);
  const [showMessageForUserProfile, setShowMessageForUserProfile] =
    useState(false);
  const selectedFiNumber = useSelector((state) => state.fiReducer?.selectedFi);

  let user = useSelector((state) => state.loginUserReducer.user);
  const hasUserUpdated = useSelector(
    (state) => state.loginUserReducer?.message
  );
  const successRef = useRef(null);

  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, [hasUserUpdated && showMessageForUserProfile]);
  const {
    location: { state },
  } = props;

  const componentAccessData =
    state?.componentAccess ||
    getComponentAccess(
      {
        function_type_code: "AS",
        label_type_code: "MP",
      },
      loginUser
    );

  return (
    <div role="main">
      {hasUserUpdated && showMessageForUserProfile && (
        <ConfirmationMessage
          message={hasUserUpdated}
          setShowMessage={setShowMessageForUserProfile}
          inputRef={successRef}
        />
      )}
      <ResponsiveBox ml={3}>
        <ResponsiveBox sx={{ width: "100%" }}>
          <ResponsiveBox
          // This sx was there, but due to bug it wasn't displaying. Comment it to remain the same as before.
            // sx={{
            //   borderBottom: 1,
            //   borderColor: "divider",
            //   marginTop: "1.5rem",
            // }}
          >
            <UserProfile
              profileId={user.internalBMOUserId || user.userId}
              pageName="account-settings"
              fiNumber={selectedFiNumber || user.fiNumber}
              setShowMessage={setShowMessageForUserProfile}
              componentAccess={componentAccessData}
              personalUser={true}
              emailHighlight={state?.emailHighlight ? true :false}
              
            />
          </ResponsiveBox>
        </ResponsiveBox>
      </ResponsiveBox>
    </div>
  );
};

export default withSidebar(AccountSettings);
